import React from 'react'
import { HighlightCard } from 'ui/cards'
import { useValue, WhenModelValue } from '@morningtrain/react-resources'
import { isArrayLike } from 'mobx'
import * as UI from 'ui'
import { getMapValue } from '@morningtrain/react-helpers'
import { Translation } from '@morningtrain/react-translations'
import OrderTransactionsSmartview from 'widgets/smartviews/inventory/OrderTransactionsSmartview'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'

export default function InventoryOrderTransactionsHighlightCard (props) {
  const transactions = useValue('delivery_transactions')

  function determineErrorCount () {
    if (!transactions) {
      return 0
    }

    let count = 0

    if (isArrayLike(transactions) && transactions.length > 0) {
      transactions.forEach(transaction => {
        if (getMapValue(transaction, 'status') === 'failed') {
          count += 1
        }
      })
    }

    return count
  }

  function determineSuccessCount () {
    if (!transactions) {
      return 0
    }

    let count = 0

    if (isArrayLike(transactions) && transactions.length > 0) {
      transactions.forEach(transaction => {
        if (getMapValue(transaction, 'status') === 'completed') {
          count += 1
        }
      })
    }

    return count
  }

  const [transactionsWithErrorCount, setTransactionsWithErrorCount] = React.useState(determineErrorCount())
  const [transactionsWithSuccessCount, setTransactionsWithSuccessCount] = React.useState(determineSuccessCount())

  React.useEffect(() => {
    setTransactionsWithErrorCount(determineErrorCount())
    setTransactionsWithSuccessCount(determineSuccessCount())
  }, [transactions])

  const hasErrors = transactions && transactionsWithErrorCount > 0
  const hasOnlySuccess = transactions && transactionsWithSuccessCount === transactions.length

  function resolveIcon () {
    if (hasErrors) {
      return <UI.Icons.ExclamationCircle />
    }
    if (hasOnlySuccess) {
      return <UI.Icons.CheckmarkCircle />
    }

    return null
  }

  function resolveColor () {
    if (hasErrors) {
      return 'red'
    }
    if (hasOnlySuccess) {
      return 'green'
    }

    return 'primary'
  }

  return (
    <WhenModelValue name='delivery_transactions'>
      <HighlightCard
        color={resolveColor()}
        box={resolveIcon()}
        title={<Translation name='inventory.fragments.transaction_status_title' />}
        content={
          hasErrors
            ? (
              <Translation
                name='inventory.fragments.transaction_status_error'
                count={transactionsWithErrorCount}
                data={{ amount: transactionsWithErrorCount }}
              />
              )
            : <Translation name='inventory.fragments.transaction_status_success' />
        }
        actions={
          (
            <MountSmartviewWithModelOnClick replace={false} smartview={<OrderTransactionsSmartview />}>
              <UI.Button>
                <Translation name='inventory.fragments.transaction_status_view_details' />
              </UI.Button>
            </MountSmartviewWithModelOnClick>
          )
        }
      />
    </WhenModelValue>
  )
}
